import createIcon from '../../createIcon';

/**
 * @component @name Work
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgNi41SDE2VjQuNUMxNiAzLjM5IDE1LjExIDIuNSAxNCAyLjVIMTBDOC44OSAyLjUgOCAzLjM5IDggNC41VjYuNUg0QzIuODkgNi41IDIuMDEgNy4zOSAyLjAxIDguNUwyIDE5LjVDMiAyMC42MSAyLjg5IDIxLjUgNCAyMS41SDIwQzIxLjExIDIxLjUgMjIgMjAuNjEgMjIgMTkuNVY4LjVDMjIgNy4zOSAyMS4xMSA2LjUgMjAgNi41Wk0xNCA2LjVIMTBWNC41SDE0VjYuNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Work = createIcon('Work', [
  [
    'path',
    {
      d: 'M20 6.5H16V4.5C16 3.39 15.11 2.5 14 2.5H10C8.89 2.5 8 3.39 8 4.5V6.5H4C2.89 6.5 2.01 7.39 2.01 8.5L2 19.5C2 20.61 2.89 21.5 4 21.5H20C21.11 21.5 22 20.61 22 19.5V8.5C22 7.39 21.11 6.5 20 6.5ZM14 6.5H10V4.5H14V6.5Z',
      key: '1fb57e',
    },
  ],
]);

export default Work;
